import { render, staticRenderFns } from "./AmountsSelect.vue?vue&type=template&id=1a9e087b&scoped=true&"
import script from "./AmountsSelect.vue?vue&type=script&lang=js&"
export * from "./AmountsSelect.vue?vue&type=script&lang=js&"
import style0 from "./AmountsSelect.vue?vue&type=style&index=0&id=1a9e087b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9e087b",
  null
  
)

export default component.exports